import {Record} from '../transit';
import * as logsActions from './actions';
import {fromJS, Map} from 'immutable';

const State = Record({
    logs: Map(),
    appLogId: 2,
    logTypes: {
        LOGOUT_POS: 'LOGOUT_POS',
        LOGIN_PIN_POS: 'LOGIN_PIN_POS',
        PIN_AUTO_LOCK: 'PIN_AUTO_LOCK',
        PIN_UNLOCK_FAILED: 'PIN_UNLOCK_FAILED'
    }
}, 'logs');

const LOGS = 'logs';
const APP_LOG_ID = 'appLogId';

const logReducer = (state = new State(), action) => {

    switch (action.type) {

        case logsActions.ADD_LOG: {
            const {logAction, userId} = action.payload;
            return state
                .update(LOGS, logs => logs.set(state.get(APP_LOG_ID), createLog(logAction, userId, state.get(APP_LOG_ID))))
                .set(APP_LOG_ID, state.get(APP_LOG_ID) + 1);
        }

        case logsActions.LOG_POST_SUCCESS: {
            const listIds = fromJS(action.payload.data);
            let newState = state;
            listIds.forEach(id => {
                newState = newState.update(LOGS, logs => logs.remove(parseInt(id)));
            });

            return newState;
        }

    }

    return state;
};

export default logReducer;

function createLog(logAction, userId, appLogId) {
    return {
        userId: userId,
        action: logAction,
        appLogId: appLogId,
        created: Date.now()
    };
}



// WEBPACK FOOTER //
// ./src/common/logs/reducer.js